import axios from '@plugins/axios'
import store from '@state/store'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
    cached: {},
}

export const getters = {}

export const actions = {
    init({ state, dispatch }) { },
    // post message habeas data, captación pos or both
    fetchInvoiceEuroSmart(context, query) {
        query = query || ''
        return axios
            .get(`${serverUrl}/euro_smart/invoices/${query}`)
            .then((response) => {
                return response.data
            })
    },

    fetchInvoiceEuroSmartCart(context, query) {
        query = query || ''
        return axios
            .get(`${serverUrl}/euro_smart_car/invoices/${query}`)
            .then((response) => {
                return response.data
            })
    },

    patchInvoiceEuroSmart(context, payload) {
        return axios
            .patch(`${serverUrl}/euro_smart/invoices/${payload.id}/`, payload)
            .then((response) => {
                return response.data
            })
    },

    patchInvoiceEuroSmartCart(context, payload) {
        return axios
            .patch(`${serverUrl}/euro_smart_car/invoices/${payload.id}/`, payload)
            .then((response) => {
                return response.data
            })
    },


}
